export default "__VITE_ASSET__DhRVU6jZ__"